package com.arena_web.pages

import androidx.compose.runtime.Composable
import com.arena_web.ui.layouts.PageLayout
import com.arena_web.ui.sections.info.InfoBullet
import com.arena_web.ui.sections.info.InfoPageScaffold
import com.arena_web.ui.sections.info.InfoParagraph
import com.arena_web.ui.sections.info.InfoSection
import com.varabyte.kobweb.core.Page

@Page("/pricing")
@Composable
fun PricingPage() {
    PageLayout(
        title = "Pricing",
        description = "Arena Pro Play pricing — free to play, with an optional Arena Access subscription for premium features.",
    ) {
        InfoPageScaffold(title = "Pricing") {
            InfoSection("Arena is free to play") {
                InfoParagraph(
                    "Creating an account, finding people nearby, joining and creating sports events, chatting, and " +
                        "tracking your player stats are all free. Premium features are unlocked with an Arena Access " +
                        "subscription."
                )
            }
            InfoSection("Arena Access subscription") {
                InfoParagraph("A single subscription unlocks all premium features:")
                InfoBullet("${'$'}14.99 per month.")
                InfoParagraph(
                    "The subscription is managed inside the app and renews monthly until cancelled. Prices in the " +
                        "iOS and Android apps are set by the Apple App Store and Google Play and may differ slightly."
                )
            }
            InfoSection("What Arena Access unlocks") {
                InfoBullet("Create Pro events with advanced features for organisers.")
                InfoBullet("AI-generated player card avatars for your profile.")
                InfoBullet("All player card designs (the default card is always free).")
            }
            InfoSection("Payments and taxes") {
                InfoParagraph(
                    "Payments are processed by our payment partners; depending on your card and country, your bank " +
                        "may convert the charge to your local currency, and applicable taxes may be reflected at " +
                        "checkout. You can cancel at any time from the app. See our Refund Policy for cancellations " +
                        "and refunds."
                )
            }
        }
    }
}
